export const FACE_EXPENSES_REQUEST = "FACE_EXPENSES_REQUEST";
export const FACE_EXPENSES_SUCCESS = "FACE_EXPENSES_SUCCESS";
export const FACE_EXPENSES_FAILED = "FACE_EXPENSES_FAILED";
